import React, { useState } from 'react';
import c from 'classnames';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import BurgerIcon from '@wix/da-ds/pkg/Icons/Burger';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import NetworkBar from '../../../NetworkBar';
import s from './Burger.scss';
var Burger = function (_a) {
    var isBurgerMenuOpen = _a.isBurgerMenuOpen, toggleBurgerMenu = _a.toggleBurgerMenu, iconClassName = _a.iconClassName, _b = _a.showNetworkBar, showNetworkBar = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var _c = useState(false), isModalOpenAnimated = _c[0], setIsModalOpenAnimated = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { size: "medium", "aria-expanded": isBurgerMenuOpen, "aria-label": t('siteHeader.burger.a11y'), "aria-controls": "burger-menu-networkbar", icon: BurgerIcon, className: iconClassName, onClick: function () {
                toggleBurgerMenu(!isBurgerMenuOpen);
            }, biData: {
                evid: BiEventType.NETWORK_BAR_MENU_ICON,
            } }),
        showNetworkBar && (React.createElement(Modal, { isOpen: isBurgerMenuOpen, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, className: c(s['modal-root'], isModalOpenAnimated && s['modal-root-animated-open']), onAfterOpen: function () {
                setIsModalOpenAnimated(true);
            }, overlayClassName: s['overlay'], bodyOpenClassName: null, onRequestClose: function () {
                setIsModalOpenAnimated(false);
                /* wait for animation to finish to remove the Modal */
                setTimeout(function () {
                    toggleBurgerMenu(false);
                }, 300);
            } },
            React.createElement(NetworkBar, { id: "burger-menu-networkbar", isVisible: isBurgerMenuOpen, className: s['networkbar'] })))));
};
Burger.displayName = 'Burger';
export default Burger;
//# sourceMappingURL=Burger.js.map